import { Slider } from "../modules/slider";

const sections = document.querySelectorAll(".icon-boxes");

if (sections.length > 0) {
    sections.forEach(section => {
        // const slider = new Slider({
        //     el: section,
        //     breakpoints: {
        //         0: {
        //             slidesPerView: 1.35,
        //             marginRight: 8,
        //         },
        //         992: {
        //             destroy: true,
        //         },
        //     },
        // })
    });
}